import React, { useState } from "react";
import { Ticket, Check } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function NewsletterForm({ variant = "dark", source = "hero" }) {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(null); // 'ok' | 'err'
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      const { data } = await api.post("/newsletter/subscribe", { email, source });
      setStatus("ok");
      setMsg(data.already_subscribed ? "You're already on the list. Stay ready." : "You're in. Watch your inbox.");
      setEmail("");
    } catch (err) {
      setStatus("err");
      setMsg(formatApiErrorDetail(err.response?.data?.detail) || "Something went wrong.");
    } finally {
      setBusy(false);
    }
  };

  const light = variant === "light";
  return (
    <form onSubmit={submit} className="w-full max-w-xl" data-testid={`newsletter-form-${source}`}>
      <div className="flex flex-col sm:flex-row gap-3">
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="ENTER EMAIL FOR EARLY ACCESS"
          className={`gs-input flex-1 ${light ? "on-light" : ""}`}
          data-testid={`newsletter-email-${source}`}
        />
        <button type="submit" disabled={busy} className={light ? "btn-primary" : "btn-primary"} data-testid={`newsletter-submit-${source}`}>
          {busy ? "…" : (
            <>
              <Ticket className="w-4 h-4" />
              CLAIM TICKET
            </>
          )}
        </button>
      </div>
      {status && (
        <div
          className={`mt-3 flex items-center gap-2 font-mono text-[11px] tracking-widest uppercase ${status === "ok" ? "text-imperial" : "text-crown"}`}
          data-testid={`newsletter-status-${source}`}
        >
          {status === "ok" && <Check className="w-3 h-3" />}
          {msg}
        </div>
      )}
      <p className={`font-mono text-[10px] tracking-[0.2em] uppercase mt-3 ${light ? "text-obsidian/60" : "text-bone/40"}`}>
        Member-only drops · Golden Ticket giveaways · No spam ever
      </p>
    </form>
  );
}
